import store from 'store2'

const getKey = (key) => store(key)

const setKey = (key, value) => {
	store(key, value)
}

const removeKey = (key) => store.remove(key)

const clear = () => {
	store(false)
}

export default {
	getKey,
	setKey,
	removeKey,
	clear
}
